import { useState, useEffect } from 'react'
import { useMaintenance } from '@/context/MaintenanceContext'
import MaintenanceBypass from './MaintenanceBypass'
import './MaintenancePage.css'
import { MAINTENANCE_CONFIG } from '@/config/maintenance'
import { FaArrowLeft } from 'react-icons/fa'
import { GrVmMaintenance } from 'react-icons/gr'
const MaintenancePage = () => {
  const { isMaintenanceMode, maintenanceMessage, isAdminBypassed } =
    useMaintenance()
  const [showBypass, setShowBypass] = useState(false)

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'M') {
        e.preventDefault()
        setShowBypass(true)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('admin') === 'true') {
      setShowBypass(true)
    }
  }, [])

  if (!isMaintenanceMode || isAdminBypassed) {
    return null
  }

  return (
    <div className='maintenance-container'>
      <div className='maintenance-icon'>
        <img src='/assets/Digipalz_bl.png' alt='Digipalz Logo' />
      </div>
      <div className='maintenance-content'>
        {showBypass && (
          <button
            className='maintenance-back-button'
            onClick={() => setShowBypass(false)}
          >
            <FaArrowLeft />
          </button>
        )}
        {showBypass ? (
          <div className='maintenance-bypass-content'>
            <MaintenanceBypass
              onSuccess={() => setShowBypass(false)}
              onBack={() => setShowBypass(false)}
            />
          </div>
        ) : (
          <>
            <div className='maintenance-icon-wrapper'>
              <GrVmMaintenance className='maintenance-icon' />
            </div>
            <h1 className='maintenance-title'>Under Maintenance</h1>

            <div className='maintenance-info'>
              <p className='maintenance-message'>
                {maintenanceMessage || MAINTENANCE_CONFIG.defaultMessage}
              </p>
            </div>

            <div className='maintenance-hint'>
              <h3>Thank you for your patience.</h3>
              <p className='maintenance-copyright'>
                © {new Date().getFullYear()} Digipalz<sup>™</sup> Corp. All
                rights reserved.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default MaintenancePage
